import { render, staticRenderFns } from "./dokum.vue?vue&type=template&id=5785810e&scoped=true&"
import script from "./dokum.vue?vue&type=script&lang=js&"
export * from "./dokum.vue?vue&type=script&lang=js&"
import style0 from "./dokum.vue?vue&type=style&index=0&id=5785810e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5785810e",
  null
  
)

export default component.exports